import cx from 'classnames'
import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren<
  {
    hasWarning: boolean
  } & (
    | {
        onClick: () => void
        disabled?: boolean
      }
    | {
        onClick?: never
        disabled?: never
      }
  )
>

export const LabelWithWarning = ({
  hasWarning,
  children,
  onClick,
  disabled = false,
  ...rest // data-testid and potentially other props
}: Props) => {
  const Component = onClick ? 'button' : 'span'

  return (
    <Component
      className={cx('p-1', {
        'text-warning-500': hasWarning,
      })}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Component>
  )
}
